import { render, staticRenderFns } from "./file-icon.vue?vue&type=template&id=e46b3d74&scoped=true&"
import script from "./file-icon.vue?vue&type=script&lang=js&"
export * from "./file-icon.vue?vue&type=script&lang=js&"
import style0 from "./file-icon.vue?vue&type=style&index=0&id=e46b3d74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46b3d74",
  null
  
)

export default component.exports